<template>
    <div>
        <v-row v-if="ready">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12" md="3">
                        <info v-if="meter && lecture" :meter="meter" :reading="lecture"/>
                    </v-col>
                    <v-col cols="12" md="3">
                        <value v-if="meter && lecture" :meter="meter" :reading="lecture" :prop="'watts'"/>
                    </v-col>
                    <v-col cols="12" md="3">
                        <value v-if="meter && lecture" :meter="meter" :reading="lecture" :prop="'amps'"/>
                    </v-col>
                    <v-col cols="12" md="3">
                        <value v-if="meter && lecture" :meter="meter" :reading="lecture" :prop="'volts'"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4" order-md="1" order-lg="1">
                        <mapMeter v-if="meter" :meter="meter"/>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex mx-auto" order-md="3" order-lg="2">
                        <control v-if="meter" :meter="meter"/>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex mx-auto" order-md="2" order-lg="3">
                        <comments :meter="meter"/>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <div v-if="ready">
            <v-row class="mt-n3">
                <v-col cols="12"> 
                   <GraphContainer v-if="meter" :meter="meter" historic :graph="new Chart({ name: 'KWH daily', props: [KWH], type: COLUMS })"/>
               </v-col>               
           </v-row>
           <v-row class="mt-n3">
                <v-col cols="12">
                    <v-card min-height="500px">
                        <v-toolbar outlined flat style="height: 60px">
                            <v-toolbar-title>
                                <v-subheader class="text-uppercase font-weight-bold primary--text pl-0">Measurements</v-subheader>
                                <v-subheader v-if="text != ''" class="text-caption text-uppercase font-weight-bold primary--text mt-n6 pl-0">{{text}}</v-subheader>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn text x-small v-model="setTimespan.btn0" :color="setTimespan.btn0 ? 'accent' : 'grey darken-3'" @click="selectButton(0, 1, 2)">Last hour</v-btn>
                                <v-btn text x-small v-model="setTimespan.btn1" :color="setTimespan.btn1 ? 'accent' : 'grey darken-3'" @click="selectButton(1, 2, 0)">12 hours</v-btn>
                                <v-btn text x-small v-model="setTimespan.btn2" :color="setTimespan.btn2 ? 'accent' : 'grey darken-3'" @click="selectButton(2, 0, 1)">24 hours</v-btn>
                            </div>
                            <v-btn icon @click="edit = true"><v-icon>mdi-cog</v-icon></v-btn>
                        </v-toolbar>
                        <div v-if="!loadgraphs">
                            <v-col cols="12">
                                <GraphContainer ref="p" v-if="meter" :compound="true" :datacomp="data.watts" ytitle="Kilowatts" :meter="meter" :graph="new Chart({ name: 'Power', lines: [LINE1, LINE2, LINE3 ], props: [WATTS], type: LINES })"/>
                            </v-col>
                            <v-col cols="12">
                                <GraphContainer ref="v" v-if="meter" :compound="true" :datacomp="data.volts" ytitle="Volts" :meter="meter" :graph="new Chart({ name: 'Voltage', props: [VOLTS], lines: [LINE1, LINE2, LINE3 ], type: LINES })"/>
                            </v-col>
                            <v-col cols="12">
                                <GraphContainer ref="c" v-if="meter" :compound="true" :datacomp="data.amps" ytitle="Amps" :meter="meter" :graph="new Chart({ name: 'Current', lines: [LINE1, LINE2, LINE3 ], props: [AMPS], type: LINES })"/>
                            </v-col>
                        </div>
                        <v-col v-else cols="12" align="center" justify="center" style="position: relative; top: 180px">
                            <v-progress-circular class="pcirc" width="5" size="50" indeterminate color="accent"></v-progress-circular>
                        </v-col>
                    </v-card>  
                </v-col>
           </v-row>
        </div>
        <v-row v-else style="height: 100%; position: relative;">
            <v-col align="center" justify="center" style="position: absolute; top: 280px">
                <v-progress-circular
                    class="pcirc"
                    width="5"
                    size="50"
                    indeterminate
                    color="accent"
                ></v-progress-circular>
            </v-col>
        </v-row>
        <v-dialog v-model="edit" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title>Display data</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="pt-6">
                    <v-card outlined>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="4" class="ma-auto">From:</v-col>
                                <v-col cols="12" md="8">
                                    <v-menu ref="start" v-model="info.open" :close-on-content-click="false" :return-value.sync="info.date" transition="scale-transition" offset-y min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="info.date" dense solo flat outlined hide-details prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker locale="es-es" v-model="info.date" no-title scrollable @change="()=>{this.$refs.start.save(info.date); info.open = false}"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="4" class="mt-2">Start:</v-col>
                                <v-col cols="12" md="8"><v-text-field v-model="info.start" flat solo outlined dense type="time"></v-text-field></v-col>
                                <v-col cols="12" md="4" style="position: relative; top: -25px" class="mt-2">End:</v-col>
                                <v-col cols="12" md="8" style="position: relative; top: -25px"><v-text-field v-model="info.end" flat solo outlined dense type="time"></v-text-field></v-col>
                            </v-row>
                        </v-card-text>
                        <transition name="shake" v-if="err.alert"><v-card-text class="text-right shake ml-n1 mt-n7 red--text only">{{ err.msg }}</v-card-text></transition>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <p v-if="processing" class="primary--text ml-4">This operation might take some minutes</p>
                    <v-spacer></v-spacer>
                    <v-btn color="accent" :loading="processing" :disabled="info.date === null" small @click="customButton()">Save</v-btn> 
                    <v-btn color="blue-grey lighten-1" dark small @click="()=>{ info = { open: false, date: null, start: '00:00', end: '23:59' }; edit = false }">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
import { LINE1, LINE2, LINE3 } from '../components/graphs/props-types'
import { WATTS, AMPS, VOLTS, KWH } from '../components/graphs/props-types'
import { COLUMS, LINES } from '../components/graphs/props-types'
import Chart from '../components/graphs/modules/Chart.js'
import tableReport from '../components/Circuit/table'
import control from '../components/Circuit/control'
import mapMeter from '../components/Circuit/map'
import value from '../components/Circuit/value'
import info from '../components/Circuit/info'
import comments from '../components/Circuit/comments'
import { GraphContainer } from "../components/graphs";
import { mapGetters, mapState, mapActions } from 'vuex'
import { Readings } from '../api'
import moment from 'moment'

export default {
    name: 'Circuit',
    components: { info, GraphContainer, tableReport, control, mapMeter, value, comments },
    computed: {
        ...mapState({
            lastReading(state){
                if(!state.meters.lastReadings) return{}
                return state.meters.lastReadings.find(m => m ? m.meter === this.$route.params.id: false)
            }
        }),
        ...mapGetters({
            getMeter: "meters/getMeter",
            getLastReading: "meters/getLastReading"
        }),
    },
    data() {
        return {
            Chart,WATTS, AMPS, VOLTS, KWH, COLUMS, 
            LINES,LINE1, LINE2, LINE3,
            ready: false,
            meter: null,
            width: 0,
            lecture: '',
            text: '',
            setTimespan: { btn0: false, btn1: false, btn2: true },
            edit: false,
            info: { open: false, date: null, start: '00:00', end: '23:59' },
            err: { alert: false, msg: '', cancel: false },
            processing: false,
            data: { watts: {}, volts: {}, amps: {} },
            hrsdef: 24,
            loadgraphs: false
        };
    },
    methods:{
        ...mapActions({ updateMeterFromApi: 'meters/updateMeterFromApi', lastReadings: 'meters/lastReadings' , lastReadingById: 'meters/lastReadingById'}),
        async refresh(){
            this.ready = false
            this.meter = this.getMeter(this.$route.params.id)
            if(this.meter) {
                await this.getMainData(this.meter)
                await this.getAddData(this.meter)
                this.lecture = this.lastReading
                localStorage.setItem('lecture', JSON.stringify(this.lecture))
            }
            if(!this.meter) {
                this.meter = JSON.parse(localStorage.getItem('meter'))
                this.lecture = JSON.parse(localStorage.getItem('lecture'))
            }
            this.hrsdef = 24
            this.text = ''
            this.setTimespan.btn0 = false; this.setTimespan.btn1 = false; this.setTimespan.btn2 = true
            this.updateChartsInfo(this.meter, this.info)
            this.ready = true
        },
        async getMainData(meter){
            await this.$store.dispatch('meters/updateMeterData', meter.name)
        },
        async getAddData(meter){
            await this.updateMeterFromApi(meter.name)
            localStorage.setItem('meter', JSON.stringify(meter))
        },
        callSB(){
            this.width = this.$root.$children[0].$data.chartWidth
        },
        async counting(){
            await this.lastReadingById(this.$route.params.id);
            this.lecture = this.lastReading
            localStorage.setItem('lecture', JSON.stringify(this.lecture))
        },
        async updateChartsInfo(meter, info){
            let apidata
            
            if (info.date != null) {
                let today = new Date(); let todayms = today.setHours(0,0,0,0); let datesel = moment(info.date).valueOf()
                let starthour = info.start.split(':').map( t => parseInt(t)); let startms = (starthour[0] * 3600 * 1000) + (starthour[1] * 60 * 1000); let st = datesel + startms
                let endhour = info.end.split(':').map( t => parseInt(t)); let endms = (endhour[0] * 3600 * 1000) + (endhour[1] * 60 * 1000); let et = datesel + endms
                apidata = await Readings.byMeter({ id: meter.name, key: meter.key }, { end: et, start: st })
                if (st >= todayms || et >= todayms) return this.err.msg = 'Timespan out of range, check your data', this.err.alert = true, this.err.cancel = true, this.loadgraphs = false, this.processing = false, await this.sleep(2000).then(() => { this.err.alert = false; })
                if (st === et) return this.err.msg = 'Duplicate data, check and try again', this.err.alert = true, this.err.cancel = true, this.loadgraphs = false, this.processing = false, await this.sleep(2000).then(() => { this.err.alert = false; })
                if (st > et) return this.err.msg = 'Data input incorrectly, check and try again', this.err.alert = true, this.err.cancel = true, this.loadgraphs = false, this.processing = false, await this.sleep(2000).then(() => { this.err.alert = false; })
                if (apidata.data.length === 0 || apidata === null || apidata === undefined || apidata.data === null || apidata.data === undefined) return this.err.msg = 'Information not available, check your data or try with other values', this.err.alert = true, this.err.cancel = true, this.loadgraphs = false, this.processing = false, await this.sleep(2000).then(() => { this.err.alert = false; })
            } else {
                apidata = await Readings.byMeter({ id: meter.name, key: meter.key }, { end: new Date().getTime(), start: new Date().getTime() - 1000 * 60 * 60 * this.hrsdef })
            }
            this.loadgraphs = true; this.processing = true; this.err.cancel = false

            Object.keys(this.data).forEach(key1 => {
                let categories = []; let series = []; let lines = { line0: [], line1:[], line2: [] }
                apidata.data.forEach( reading => {
                    let date = new Date(reading.timestamp); categories.push(date.toLocaleTimeString().slice(0, -3))
                    reading.lines.forEach((line, i) => { lines[`line${i}`].push({x: date.getTime(), y: key1 === 'watts' ? (line[key1]/1000).toFixed(2) : line[key1].toFixed(2) }) })
                })
                Object.keys(lines).forEach((key2, i) => { series.push({data: lines[key2], line: i.toString(), prop: key1}) })
                this.data[key1].categories = categories; this.data[key1].series = series
            })
            if (info.date != null) {
                this.text = `${moment(this.info.date).format('L')} @ ${this.info.start}-${this.info.end}`
                this.setTimespan.btn0 = false; this.setTimespan.btn1 = false; this.setTimespan.btn2 = false
            }
            this.info = { open: false, date: null, start: '00:00', end: '23:59' }
            await this.sleep(2000).then(() => { this.loadgraphs = false; this.edit = false; this.processing = false })
        },
        async selectButton(t, f1, f2){
            this.text = ''
            this.loadgraphs = true
            this.setTimespan[`btn${t}`] = true; this.setTimespan[`btn${f1}`] = false; this.setTimespan[`btn${f2}`] = false
            let selhours = [1, 12, 24]; this.hrsdef = selhours[t]
            this.updateChartsInfo(this.meter, this.info)
            this.$refs.p.data = this.data.watts; this.$refs.v.data = this.data.volts; this.$refs.c.data = this.data.amps
            await this.sleep(2000).then(() => { this.loadgraphs = false; })
        },
        async customButton(){
            this.updateChartsInfo(this.meter, this.info)
            if(this.err.cancel) return 
            this.$refs.p.data = this.data.watts; this.$refs.v.data = this.data.volts; this.$refs.c.data = this.data.amps
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
    },
    watch:{
        '$route.params.id'(){
            this.refresh()
        },
    },
    mounted() {
        this.refresh()
        this.callSB()
        this.fn = setInterval(() => { this.counting() }, 60 * 1000)
    },
    beforeDestroy() {
        if(this.$route.name != 'Circuit') {
            localStorage.removeItem('meter')
            localStorage.removeItem('lecture')
            localStorage.removeItem('collection')
        }
    },
}
</script>

<style scoped>
.shake {
    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
}
@keyframes shake {
    10%, 90% { transform: translate3d(-1px, 0, 0); }
    20%, 80% { transform: translate3d(2px, 0, 0); }
    30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
    40%, 60% { transform: translate3d(4px, 0, 0); }
}
.only{
    position: relative;
    top: -50px
}
</style>